<div class="formulaire col-md-8 col-8">
  <h1 class="title">{{ introductionMessages.libelle | translate}}</h1>
  <p class="spanPad">{{ introductionMessages.paragrapheA | translate}}</p>
  <p class="spanPad">{{ introductionMessages.paragrapheB | translate}}</p>
  <p class="spanPad">{{ introductionMessages.paragrapheC | translate}}</p>
  <p>{{ introductionMessages.paragrapheD | translate}}</p>
</div>
